import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { handleError } from 'src/app/shared/functions/error-handler';
import { ISedmsFormOutput } from 'src/app/shared/interfaces/form/sedms-form-output.model';
import { AppConfigService } from '../../../../services/app-config.service';
import { IAppConfig } from '../../../../shared/interfaces/app-config';
import { FinalNoticeOfWithdrawalSaveRequest } from '../models/final-notice-of-withdrawal/final-notice-of-withdrawal-save.model';
import { NPSSchoolSearch } from '../models/p2-package/search-nps-list';
import { isEmpty } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class OutreachService<T extends ISedmsFormOutput> {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
  ) {
    this.config = this.appConfigService.getConfig();
  }

  // TODO: This endpoint should return the following type: Observable<ApiResponse<OutReachDetails>> but currently getting a lot of errors. Will fix at a later point in time
  public submit(request: T): Observable<any> {
    return this.http
      .post(`${this.config.apiUrl}/OutReach/Add`, request)
      .pipe(catchError(handleError));
  }

  // TODO: This endpoint should return the following type: Observable<ApiResponse<OutReachDetails>> but currently getting a lot of errors. Will fix at a later point in time
  public get(outreachSK: string): Observable<any> {
    return this.http
      .get<any>(`${this.config.apiUrl}/OutReach/Get/` + outreachSK)
      .pipe(
        map((res: any) => (!res ? {} : res)),
        catchError(handleError),
      );
  }

  public getStatus(
    studentSK: string,
    caseactionType: number,
    caseactionSubType: number,
  ): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${this.config.apiUrl}/OutReach/Getstatus/` +
          studentSK +
          '/' +
          caseactionType +
          '/' +
          caseactionSubType,
      )
      .pipe(catchError(handleError));
  }

  previewdocument(
    outreach: FinalNoticeOfWithdrawalSaveRequest,
    nycId: string,
  ): Observable<Uint8Array> {
    return this.http
      .post<Uint8Array>(
        `${this.config.apiUrl}/DocumentGen/PreviewOutreachDocument?nycid=${nycId}`,
        outreach,
      )
      .pipe(catchError(handleError));
  }
  public getNPSSchoolLists(
    searchNPSSchoolList: NPSSchoolSearch,
  ): Observable<any> {
    let params: HttpParams = new HttpParams();

    if (!isEmpty(searchNPSSchoolList?.locationName)) {
      params = params.set('locationName', searchNPSSchoolList.locationName);
    }

    if (!isEmpty(searchNPSSchoolList?.locationCode)) {
      params = params.set('locationCode', searchNPSSchoolList.locationCode);
    }
    return this.http
      .get<any[]>(`${this.config.apiUrl}/NPSReferral/GetNPSSchools`, { params })
      .pipe(catchError(handleError));
  }

  public getGeneratedDocumentHtml(
    studentSk: string,
    caseActionSk: string,
    documentType: number,
  ): Observable<string> {
    return this.http
      .get(
        `${this.config.apiUrl}/DocumentGen/GetGeneratedDocumentHtml/${studentSk}/${caseActionSk}/${documentType}`,
        { responseType: 'text' }
      )
      .pipe(catchError(handleError));
  }
}
